import { IProductDetail } from '@/api/types/public';
import { Box } from '@mui/material';
import { useTranslations } from '@/i18n/use-translations';
import GoodsDetailCollapse from './GoodsDetailCollapse';
import ProductDescription from './ProductDescription';

interface ProductDescriptionPropsCollapse {
  detail: IProductDetail;
  SDProductDetailsPageBtnClick?: (btnName: string) => void;
  defaultOpen?: boolean;
}
export default function ProductDescriptionCollapse(props: ProductDescriptionPropsCollapse) {
  const t = useTranslations('goodsDetail.productDescription');
  if (!props.detail?.show_description) {
    return null;
  }
  return (
    <GoodsDetailCollapse
      title={t('title')}
      defaultOpen={props.defaultOpen ?? true}
      onChange={() => props.SDProductDetailsPageBtnClick?.('Product Description')}
    >
      <Box className="mb-24">
        <ProductDescription detail={props.detail} />
      </Box>
    </GoodsDetailCollapse>
  );
}
